<template>
  <div fluid class="start-container fill-height" :style="{ 'padding-bottom': step != 3 ? '40px' : '0px' }"
    :class="step != 3 || educationStep == 1 ? 'pt-8' : ($vuetify.breakpoint.smAndUp ? 'pt-0' : 'pt-0')">
    <v-row v-if="step == 0" justify="center" align="center" class="px-3">
      <v-col cols="12" md="8" lg="6" xl="5">
        <div class="text-center">
          <div class="header-badge mb-6">
            <span style="color: #4dd453">Selecciona un idioma</span>
          </div>

          <h1 class="font-weight-bold mb-8" style="font-size: 3rem; line-height: 1.1; letter-spacing: -0.03em;">
            Quiero aprender en <span class="gradient-text">{{ idiomaName }}</span>
          </h1>
        </div>

        <v-row>
          <!-- Primera fila de idiomas -->
          <v-col v-for="(idioma, i) in idiomas" :key="i" cols="6" sm="3">
            <v-card :class="{ 'selected-language': idiomaSeleccionado === idioma.id, '': true }" class="language-card"
              @click="seleccionarIdioma(idioma.id)" :ripple="false" flat>
              <v-card-text class="text-center">
                <div class="d-flex flex-column align-center">
                  <v-img :src="idioma.bandera" alt="Bandera" class="language-flag mb-3" />
                  <h3 class="subtitle-1 font-weight-medium">{{ idioma.nombre }}</h3>
                  <!-- <p class="body-2 mt-1 grey--text text--darken-1">{{ idioma.estudiantes }}</p> -->
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>



        <!-- <v-row class="mt-8" v-if="idiomaSeleccionado">
          <v-col cols="12" class="text-center">
            <v-btn 
              color="primary" 
              large 
              rounded 
              @click="confirmarSeleccion"
              class="primary-btn"
            >
              Continuar
            </v-btn>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>

    <v-row v-if="step == 1" justify="center" align="center">
      <v-col cols="12" md="8" lg="6" xl="5" style="max-width: 700px !important;" class="mx-auto">
        <div class="text-center mb-8">
          <h1 class="font-weight-bold mb-4" style="font-size: 2.5rem; line-height: 1.1; letter-spacing: -0.03em;">
            ¡Bienvenido a <span class="gradient-text">SeleAI</span>!
          </h1>

          <p class="subtitle-1 mb-8">
            Te haremos algunas preguntas básicas para personalizar tu experiencia.
          </p>
        </div>

        <div class="question-container mb-6">
          <h2 class="font-weight-bold mb-6" style="font-size: 1.5rem;">
            ¿Qué te motiva más cuando estudias?
          </h2>

          <div class="options-container">
            <v-card v-for="(option, i) in motivationOptions" :key="i" @click="selectMotivation(option)"
              :class="{ 'selected-option': selectedMotivation === option }" class="option-card mb-3" flat hover>
              <v-card-text class="pa-4">
                {{ option.text }}
              </v-card-text>
            </v-card>

            <!-- <v-btn 
              color="primary" 
              block
              large
              :disabled="!selectedMotivation"
              @click="continuarMotivacion"
              class="primary-btn mt-6"
            >
              Continuar
            </v-btn> -->
          </div>
        </div>
      </v-col>
    </v-row>

    <div v-if="step == 2">
      <div style="max-width: 700px !important;" class="mx-auto">
        <div class="mx-auto text-center mb-8">
          <h1 class="font-weight-bold mb-4" style="font-size: 2.5rem; line-height: 1.1; letter-spacing: -0.03em;">
            ¿Cómo conociste <span class="gradient-text">SeleAI</span>?
          </h1>

          <p class="subtitle-1 mb-8">
            Nos ayuda a mejorar nuestra difusión.
          </p>
        </div>

        <div class="question-container mb-6">
          <div class="options-container">
            <v-card v-for="(source, i) in discoverySources" :key="i" @click="selectDiscoverySource(source)"
              :class="{ 'selected-option': selectedDiscoverySource === source }"
              class="option-card mb-3 no-background-hover" :ripple="false" flat hover>
              <v-card-text class="pa-4">
                {{ source.text }}
              </v-card-text>
            </v-card>

            <div v-if="selectedDiscoverySource && selectedDiscoverySource.id === 'other'" class="mt-4 mb-4">
              <v-text-field v-model="otherSource" outlined :autofocus="true" maxlength="80" :counter="80"
                placeholder="Cuéntanos cómo nos conociste..."
                :rules="[v => !!v || 'Este campo es obligatorio', v => v.length <= 80 || 'Máximo 80 caracteres']"></v-text-field>
            </div>

            <!-- <v-btn 
              color="primary" 
              block
              large
              :disabled="!canContinueDiscovery"
              @click="continuarDiscovery"
              class="primary-btn mt-6"
            >
              Continuar
            </v-btn> -->
          </div>
        </div>
      </div>
    </div>

    <div v-if="step == 3" class="d-flex flex-column align-center" :class="{ 'pb-12': educationStep == 1 }">
      <div v-if="educationStep == 1" class="text-center mb-4">
        <h1 class="font-weight-bold mb-4" style="font-size: 2.5rem; line-height: 1.1; letter-spacing: -0.03em;">
          Encuentra lo que <span class="gradient-text">necesitas</span>
        </h1>

        <p class="subtitle-1 mb-8">
          Cuéntanos qué estudias y accede a contenido que te ayudará con tus exámenes
        </p>
      </div>

      <education-form :user-id="$root.currentUser.userId" :step.sync="educationStep"
        @completed="onEducationCompleted" />
    </div>
  </div>
</template>

<script>
import EducationForm from '@/components/user/EducationForm.vue';

export default {
  name: 'Start',
  components: {
    EducationForm
  },
  async mounted() {
    console.log("currentUser", this.$root.currentUser)
    const subjects = await this.fetchSubjects()

    if (subjects.length > 0 && (!this.$route.query || this.$route.query.from !== 'app')) {
      this.$router.push({ path: "/app" })
    }
  },
  data() {
    return {
      idiomaSeleccionado: "es",
      idiomas: [

        {
          nombre: 'Español',
          bandera: require('@/assets/flags/ES.svg'),
          id: 'es'
        },
        {
          nombre: 'Catalán',
          bandera: require('@/assets/flags/catalonia.svg'),
          id: 'ca'
        },
        {
          nombre: 'Inglés',
          bandera: require('@/assets/flags/US.svg'),
          id: 'en'
        },
        {
          nombre: 'Francés',
          bandera: require('@/assets/flags/FR.svg'),
          id: 'fr'
        },
        {
          nombre: 'Portugués',
          bandera: require('@/assets/flags/BR.svg'),
          id: 'pt'
        },
        {
          nombre: 'Italiano',
          bandera: require('@/assets/flags/IT.svg'),
          id: 'it'
        },
        {
          nombre: 'Alemán',
          bandera: require('@/assets/flags/DE.svg'),
          id: 'de'
        },
        {
          nombre: 'Ruso',
          bandera: require('@/assets/flags/RU.svg'),
          id: 'ru'
        },

        {
          nombre: 'Sueco',
          bandera: require('@/assets/flags/SE.svg'),
          id: 'sv'
        },
        {
          nombre: 'Chino',
          bandera: require('@/assets/flags/CN.svg'),
          id: 'zh'
        },
        {
          nombre: 'Japonés',
          bandera: require('@/assets/flags/JP.svg'),
          id: 'ja'
        },
        {
          nombre: 'Coreano',
          bandera: require('@/assets/flags/KR.svg'),
          id: 'ko'
        }
      ],
      selectedMotivation: null,
      motivationOptions: [
        { id: "grades", text: "Obtener las mejores calificaciones" },
        { id: "efficiency", text: "Ahorrar tiempo y estudiar más eficientemente" },
        { id: "exams", text: "Hacerlo bien en los próximos exámenes" },
        { id: "university", text: "Entrar en una buena universidad" },
        { id: "skills", text: "Mejorar mis habilidades y conocimientos" }
      ],
      selectedDiscoverySource: null,
      otherSource: "",
      discoverySources: [
        { id: "tiktok", text: "TikTok" },
        { id: "facebook", text: "Facebook/Instagram" },
        { id: "youtube", text: "Youtube" },
        { id: "google", text: "Google Search" },
        { id: "examenselectivitat", text: "Examenselectivitat.cat" },
        { id: "sele", text: "Sele.es" },
        { id: "amigos", text: "Amigos" },
        { id: "other", text: "Otro" }
      ],
      educationStep: 1
    }
  },
  computed: {
    step() {
      if (this.$route.path === "/start")
        return 0
      if (this.$route.path === "/start-1")
        return 1
      if (this.$route.path === "/start-2")
        return 2
      if (this.$route.path === "/start-3")
        return 3
    },
    canContinueDiscovery() {
      if (!this.selectedDiscoverySource) return false;
      if (this.selectedDiscoverySource.id === 'other' && !this.otherSource.trim()) return false;
      return true;
    },
    idiomaName() {
      const idioma = this.idiomas.find(i => i.id == this.idiomaSeleccionado)
      console.log("idioma", idioma)
      if (idioma) {
        return idioma.nombre
      }

      return ""
    }
  },
  methods: {
    async fetchSubjects() {

      try {
        // Obtener las asignaturas del usuario actual
        const response = await this.axios.get('/education/user-subjects', {
          headers: {
            Authorization: this.$root.token.value
          },
          params: {
            user_id: this.userId || this.$root.currentUser.userId
          }
        });

        if (response.data && Array.isArray(response.data)) {
          return response.data;
        } else {
          return [];
        }
      } catch (err) {
        console.error('Error al cargar las asignaturas:', err);
        return [];
      }
    },
    seleccionarIdioma(idioma) {
      this.idiomaSeleccionado = idioma;
      this.confirmarSeleccion();
    },
    confirmarSeleccion() {
      // Avanzar al siguiente paso en lugar de navegar a otra ruta
      this.$router.push({ path: "/start-1?lang=" + this.idiomaSeleccionado })
    },
    selectMotivation(option) {
      this.selectedMotivation = option;
      this.continuarMotivacion();
    },
    continuarMotivacion() {
      // Obtener los parámetros actuales de la URL
      const currentQuery = this.$route.query;
      // Combinar los parámetros actuales con el nuevo parámetro de motivación
      this.$router.push({
        path: "/start-2",
        query: {
          ...currentQuery,
          mot: this.selectedMotivation.id
        }
      })
    },
    async continuarDiscovery() {
      // Obtener los parámetros actuales de la URL
      const currentQuery = this.$route.query;
      // Combinar los parámetros actuales con el nuevo parámetro de motivación
      const query = {
        src: this.selectedDiscoverySource.id,
      }

      if (this.selectedDiscoverySource.id === 'other')
        query["src_other"] = this.otherSource.trim()

      // const descoveryQuery = {
      //   step: currentQuery.step ? currentQuery.step : 5,
      //   studyType: currentQuery.studyType ? currentQuery.studyType : 4,
      //   center: currentQuery.center ? currentQuery.center : 220,
      //   course: currentQuery.course ? currentQuery.course : 2032
      // }

      // delete currentQuery.step;
      // delete currentQuery.studyType;
      // delete currentQuery.center;
      // delete currentQuery.course;


      await this.$router.push({
        path: "/start-3",
        // query: {
        //   ...currentQuery,
        //   ...query
        // }
        // query: {...currentQuery, ...query, ...descoveryQuery }
        query: {...currentQuery, ...query }
      })
    },
    selectDiscoverySource(source) {
      this.selectedDiscoverySource = source;
      if (source.id !== 'other') {
        this.continuarDiscovery();
      }
    },
    async guardar() {
      try {

        // Validar que tenemos los datos necesarios
        // if (!this.selectedDiscoverySource || !this.$route.query.lang || !this.$route.query.mot) {
        //   console.error("Faltan datos requeridos para continuar");
        //   return;
        // }

        // Verificar que el usuario está autenticado
        if (!this.$root.currentUser || !this.$root.currentUser.userId) {
          console.error("Usuario no autenticado");
          return;
        }

        // Preparar los datos para enviar
        const userData = {
          lang: this.$route.query.lang ? String(this.$route.query.lang) : null,
          mot: this.$route.query.mot ? String(this.$route.query.mot) : null,
          src: this.selectedDiscoverySource && this.selectedDiscoverySource.id ? String(this.selectedDiscoverySource.id) : null,
          src_other: this.selectedDiscoverySource && this.selectedDiscoverySource.id === 'other' ? this.otherSource.trim() : null,
          user_id: this.$root.currentUser.userId,
        };

        // Enviar los datos y capturar la respuesta
        const response = await this.axios.post("/user-info", userData);

        if (response.status === 200) {
          console.log("Información de usuario guardada correctamente:", response.data.messageId);
          // Redirigir a la ruta que muestra el paso 3 (educación)
          // this.$router.push({
          //   path: "/start-3",
          //   query: { ...this.$route.query }
          // });
        } else {
          console.error("Error al guardar la información:", response.data.messageId);
          alert("No se pudo guardar la información. Por favor, inténtalo de nuevo.");
        }
      } catch (error) {
        console.error("Error al guardar la información del usuario:", error);
        alert("Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.");
      }
    },

    // Método para cuando se completa el formulario de educación
    async onEducationCompleted() {
      await this.guardar()

      // this.$router.push({
      //   path: "/start-plan",
      //   query: { ...this.$route.query }
      // });

      this.$router.push({
        path: "/app",
        query: { ...this.$route.query }
      });
    }
  },
  watch: {
    otherSource(newValue, oldValue) {
      if (this.selectedDiscoverySource && this.selectedDiscoverySource.id === 'other' && newValue && newValue.trim() && newValue !== oldValue) {
        this.continuarDiscovery();
      }
    }
  }
}
</script>

<style scoped>
.start-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #6cf30547, rgba(255, 255, 255, 0.7) 70%);
  background-attachment: scroll;
  background-position: 0 0;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

h1,
h2,
h3,
h4,
.text-h1,
.text-h2,
.text-h3,
.text-h4 {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 900 !important;
  color: #4b4b4b !important;
  letter-spacing: -0.03em !important;
}

.subtitle-1,
p,
span,
div {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  color: #4b4b4b;
}

.gradient-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.header-badge {
  background: #fff;
  color: #4dd453;
  border-radius: 16px;
  padding: 4px 16px;
  font-weight: 600;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e9e9e9;
  margin: 0 auto;
}

.language-card {
  border-radius: 16px;
  transition: all 0.3s;
  cursor: pointer;
  height: 100%;
  border: 2px solid transparent;
  overflow: hidden;
}

.language-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1) !important;
}

.language-flag {
  width: 64px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
}

.selected-language {
  border: 2px solid #4dd453 !important;
  box-shadow: 0 4px 8px rgba(28, 176, 246, 0.2) !important;
}

.primary-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 800 !important;
  font-size: 1.05rem !important;
  border-radius: 16px !important;
  transition: filter 0.2s ease, transform 0.1s ease !important;
  border: 2px solid #4dd453 !important;
  height: 48px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: #4dd453 !important;
  box-shadow: 0 4px 0 #42b848 !important;
  color: white !important;
}

.primary-btn:hover {
  filter: brightness(1.02);
  box-shadow: 0 4px 0 #58a700 !important;
  transform: translateY(0) !important;
}

.primary-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: translateY(4px) !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  border: 2px solid #cccccc !important;
  background: #e0e0e0 !important;
  box-shadow: 0 4px 0 #b0b0b0 !important;
  color: #888888 !important;
  opacity: 0.7;
  cursor: not-allowed;
}

/* Nuevos estilos para el paso 2 */
.avatar-circle {
  width: 100px;
  height: 100px;
  background-color: #e0ffea;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border: 2px solid #e0ffea;
}

.avatar-text {
  font-size: 36px;
  color: #42b848;
  font-weight: bold;
}

.question-container {
  background-color: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.option-card {
  border-radius: 12px !important;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 2px solid #e0e0e0;
}

.option-card:hover {
  border-color: #42b848;
}

.selected-option {
  border: 2px solid #42b848 !important;
  background-color: #e9feec !important;
}
</style>
